import { lazy, Suspense } from 'react';
import styled from 'styled-components';

import { REACT_APP } from '../../config/env';
import Sidebar from '../Sidebar/Sidebar';

import AppModalsMiscState from './AppModalsMiscState';

const LayoutOptimizeOnly = lazy(
  () =>
    import(/* webpackChunkName: 'LayoutOptimizeOnly' */ './LayoutOptimizeOnly'),
);

const ContentWrapper = styled.div.attrs({ role: 'main' })`
  position: relative;
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  background-color: white;
`;

const LayoutProtected = ({ children }) => {
  const useLayoutOptimizeOnly =
    REACT_APP.ENABLE_DEDICATED_WRITING_EXPERIENCE === 'true';

  if (useLayoutOptimizeOnly) {
    return (
      <Suspense fallback={<ContentWrapper>{children}</ContentWrapper>}>
        <LayoutOptimizeOnly>
          <AppModalsMiscState />
          <ContentWrapper>{children}</ContentWrapper>
        </LayoutOptimizeOnly>
      </Suspense>
    );
  }

  return (
    <>
      <Sidebar />
      <AppModalsMiscState />
      <ContentWrapper>{children}</ContentWrapper>
    </>
  );
};

export default LayoutProtected;
